import { WindIndicator } from './WindIndicator.tsx';

export const DirectionIndicator: React.FC<{ direction: number }> = ({ direction }) => {
    let invertedDirection = direction + 180;
    if (invertedDirection > 360){
        invertedDirection = invertedDirection - 360;
    }
    return <WindIndicator direction={invertedDirection}/>;
};
